export default "__VITE_PUBLIC_ASSET__b2bb651c__"